const subscribeButtons = document.querySelectorAll('.site-header__link--subscribe');
const memberCenterButton = document.querySelector('.fp-member-center');

function updateVisibility() {
  const isLoggedIn = memberCenterButton.style.display !== 'none';
  subscribeButtons.forEach((btn) => {
    // eslint-disable-next-line no-param-reassign
    btn.style.display = isLoggedIn ? 'none' : 'inline-block';
  });
}

if (subscribeButtons.length && memberCenterButton) {
  new MutationObserver(updateVisibility).observe(memberCenterButton, {
    attributes: true,
    attributeFilter: ['style'],
  });

  updateVisibility();
}
